<template>
  <w-tool-tabs class="tab-button" size="mini" v-model="activeTab">
    <el-tab-pane label="호스트 클러스터" name="WTopologymapHostClusterPerfTable">
      <w-topologymap-host-cluster-perf-table :active="active && activeTab === 'WTopologymapHostClusterPerfTable'" />
    </el-tab-pane>
    <el-tab-pane label="호스트" name="WTopologymapHostPerfTable">
      <w-topologymap-host-perf-table :active="active && activeTab === 'WTopologymapHostPerfTable'" />
    </el-tab-pane>
    <el-tab-pane label="VM" name="WTopologymapVmPerfTable">
      <w-topologymap-vm-perf-table :active="active && activeTab === 'WTopologymapVmPerfTable'" />
    </el-tab-pane>
    <el-tab-pane label="스토리지 클러스터" name="WTopologymapStorageClusterPerfTable">
      <w-topologymap-storage-cluster-perf-table :active="active && activeTab === 'WTopologymapStorageClusterPerfTable'" />
    </el-tab-pane>
    <el-tab-pane label="스토리지" name="WTopologymapStoragePerfTable">
      <w-topologymap-storage-perf-table :active="active && activeTab === 'WTopologymapStoragePerfTable'" />
    </el-tab-pane>
  </w-tool-tabs>
</template>

<script>
import WTopologymapHostClusterPerfTable from '@/views/topologymap/components/perfoper/performance/components/virtual/TopologymapHostClusterPerfTable';
import WTopologymapHostPerfTable from '@/views/topologymap/components/perfoper/performance/components/virtual/TopologymapHostPerfTable';
import WTopologymapVmPerfTable from '@/views/topologymap/components/perfoper/performance/components/virtual/TopologymapVmPerfTable';
import WTopologymapStorageClusterPerfTable from '@/views/topologymap/components/perfoper/performance/components/virtual/TopologymapStorageClusterPerfTable';
import WTopologymapStoragePerfTable from '@/views/topologymap/components/perfoper/performance/components/virtual/TopologymapStoragePerfTable';

export default {
  name: 'WTopologymapVirtualPerfView',
  components: {
    WTopologymapHostClusterPerfTable,
    WTopologymapHostPerfTable,
    WTopologymapVmPerfTable,
    WTopologymapStorageClusterPerfTable,
    WTopologymapStoragePerfTable,
  },
  props: {
    active: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      activeTab: 'WTopologymapHostClusterPerfTable',
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/topologymap/components/perfoper/performance/components/TopologymapVirtualPerfView.vue